<template>
  <div class="breast-implant-warnings graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">Breast implant patients kept in the dark about potential risks</h3>
    <p v-if="showDeck">More than 300 people around the world who responded to an ICIJ survey said they were not aware of the dangers of breast implants prior to their surgeries.</p>
    <bar-chart :chart-height-ratio="baseHeightRatio" :chart-data="data" :chart-options="options"></bar-chart>
    <p class="chart-source">Nore: Respondents were self-selected and not meant to be a representative sample. Source: ICIJ online survey (Nov. 2018)</p>
  </div>
</template>

<script>
  import data from '../assets/breast-implant-warnings.json'
  import BarChart from '@/components/BarChart.vue'
  import embeddable from '../mixins/embeddable'

  const options = {
    chartName: "breast-implant-warnings",
    barHeight: 30,
    barGap: 10,
    barColor: "#F8B700",
    xAxisTicks: 3,
    xAxisTickFormat: d => {return d === 0 ? d : d + "%";},
    labelWidth: 220,
  }

  export default {
    name: 'BmjRecallRate',
    mixins: [embeddable],
    components: {
      BarChart,
    },
    data() {
      return {
        data,
        options
      }
    }
  }
</script>
